const baseUrl = "https://api.aeroprime.in/";

export const apiUrl = {
  getAirline: `${baseUrl}crm-service/search/originList`,
  getAirline1: `${baseUrl}crm-service/search/originList`,
  getAirline2: `${baseUrl}crm-service/search/originList`,
  getAirline3: `${baseUrl}crm-service/search/originList`,
  auditLogs: `${baseUrl}crm-service/audit/logs`,
  fareRuleList: `${baseUrl}crm-service/fareRule/list`,
  fareRuleSaveUpdate: `${baseUrl}crm-service/fareRule/saveUpdate`,
  fareRuleGet: `${baseUrl}crm-service/fareRule/get`,
  fareRuleDelete: `${baseUrl}crm-service/fareRule/delete`,
};
